export default __webpack_public_path__ + "images/CX.5c4afe7.png";